import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthoritytreeService {

  baseUrl = environment.apiUrl;

constructor(
  private http: HttpClient,
) {}

  buildAuthorityTree(rootAuthorityUnitId: number) {
    return this.http.get(this.baseUrl + `authoritytree/GetAuthorityTree/` + rootAuthorityUnitId);
  }

  getAllAuthorityLocations(model: any) {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
    return this.http.post(this.baseUrl + `Site/AuthorityTree`, model, {headers: httpHeaders, observe: 'response'});
  }

  getLocationCheckBoxes() {
    return this.http.get(this.baseUrl + 'authorities/LocationCheckBoxes');
  }

  createLocation(model: any) {
    return this.http.post(this.baseUrl + `authorities/create`, model);
  }

  removeLocation(id: number) {
    return this.http.delete(this.baseUrl + 'authorities/' + id);
  }

  updateLocation(updateModel: any) {
    return this.http.post(this.baseUrl + 'authorities/updateHierarchy', updateModel);
  }
}